import { Colors } from "@/enums/Colors";
import { MoreHoriz } from "@mui/icons-material";
import { Box, Menu, menuClasses, menuItemClasses, styled, typographyClasses } from "@mui/material";

export const FilesStyledTable = styled("table")(({ theme }) => ({
  borderCollapse: "collapse",
  tableLayout: "auto",
  width: "100%",
  th: {
    fontSize: "0.813rem",
    fontWeight: 600,
    color: Colors.LIGHT_GRAY_8A8E93,
    textAlign: "start",
    padding: "0.75rem 1rem",
    borderBottom: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
    borderRight: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
    backgroundColor: Colors.LIGHT_GRAY_F4F4F4,
    whiteSpace: "nowrap",
    ":last-of-type": {
      borderRight: "none",
      textAlign: "center",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
      padding: "0.5rem 0.75rem",
    },
  },
  "tbody tr": {
    ":hover": {
      cursor: "pointer",
      backgroundColor: Colors.LIGHT_GRAY_F4F4F4,
    },
  },
  "tbody tr:not(:last-of-type) td": {
    borderBottom: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
  },
  td: {
    padding: "0.625rem 1rem",
    borderRight: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
    maxWidth: "100px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    ":last-of-type": {
      borderRight: "none",
      textAlign: "center",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0.75rem",
      maxWidth: "80px",
    },
    [`& .${typographyClasses.root}`]: {
      "&.filename-container": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "0.75rem",
        fontWeight: "400",
        paddingRight: "0.5rem",
        lineHeight: "18px",
        [theme.breakpoints.down("md")]: {
          fontSize: "0.7rem",
          lineHeight: "16px",
        },
      },
      fontSize: "0.75rem",
      fontWeight: "400",
      [theme.breakpoints.down("md")]: {
        fontSize: "0.7rem",
      },
    },
  },
}));

export const FileTableHeaderCellContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
  ":hover": {
    cursor: "pointer",
  },
}));

export const FileTableMoreHoriz = styled(MoreHoriz)(() => ({
  width: "22px",
  height: "22px",
  padding: "0.25rem",
  borderRadius: "100%",
  ":hover": {
    backgroundColor: Colors.BUTTON_SECONDARY_HOVER_PURPLE,
    cursor: "pointer",
  },
}));

export const FileTableMenu = styled(Menu)(() => ({
  left: "-1.5rem",
  [`& .${menuClasses.list}`]: {
    padding: 0,
    width: "fit-content",
  },
  [`& .${menuClasses.paper}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    borderRadius: "0.25rem",
    border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
    [`& .${menuItemClasses.root}`]: {
      display: "flex",
      padding: "0.375rem 0.75rem",
      gap: "0.5rem",
      alignItems: "center",
      alignSelf: "stretch",
      [`& .${typographyClasses.root}`]: {
        fontWeight: 400,
        fontSize: "0.875rem",
      },
    },
  },
}));
